import React, {useMemo, useEffect} from 'react';
import {Col, Container, Row} from 'reactstrap';
import PopupHeadlineComponent from './PopupSharedComponents/PopupHeadlineComponent';
import PopupDescriptionComponent from './PopupSharedComponents/PopupDescriptionComponent';
import CallBackComponent from './PopupSharedComponents/CallBackComponent';
import BtnSubmit from "../../../Shared/Buttons/BtnSubmit";
import BtnWhite from "../../../Shared/Buttons/BtnWhite";
import BtnWhiteBlackBorderSmallSize from "../../../Shared/Buttons/BtnWhiteBlackBorderSmallSize";
import PopupImageComponent from "./PopupSharedComponents/PopupImageComponent";


const IndependentPurchasePermissionPopUp = (props) => {
    return (
        <Container className="IndependentPurchasePermissionPopUp">
            <PopupImageComponent icon={require('./images/lampIcon/lamp.svg')} />
            <PopupHeadlineComponent title={"שימו לב!"}/>
            <PopupDescriptionComponent
                boldDescription={"במקרה בו חבילת הגלישה שנרכשה מסתיימת, הריני מאשר למנוי המצוין לרכוש חבילת המשך וכי החברה תישא בכל העלויות על סמך אישור זה"}/>
            <Row className="buttonsRow">
                <BtnWhiteBlackBorderSmallSize text={'נמשיך בלי'} onclick={() => {
                    props.props.setReadyToPurchaseForBusinessIndividualAndSetAllowIndependentFuturePurchases(false);
                }}/>
                <BtnSubmit  text={'אישור'} onclick={() => {
                   props.props.setReadyToPurchaseForBusinessIndividualAndSetAllowIndependentFuturePurchases(true);
                }} />
            </Row>
        </Container>
    );
};
export default IndependentPurchasePermissionPopUp;
